import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Typography from "@mui/material/Typography";
import { observer } from "mobx-react";
import * as React from "react";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AutoPay from "../../components/AutoPay/AutoPay";
import DashboardCards from "../../components/Dashboard.cards/DashboardCards";
import NocTabs from "../../components/NOC.Tabs/NOC.tabs";
import Notifications from "../../components/Notifications/Notifications";
import PaymentTabs from "../../components/PaymentTabs.MUI/PaymentTabs";
import ProfileTabs from "../../components/Profile/Profile.tabs";
import ServicesTab from "../../components/ServicesTab/ServicesTab";
import AccountGrid from "../../components/Temporary Components/AccountsGrid";
import General from "../../stores/GeneralStore";
import User from "../../stores/UserStore";
import { TabWithCount } from "../SocialCase/SocialCase";
import { TabPanelProps, a11yProps } from "./Tabs.interface";
import { Button, Div, NotificationButton } from "./tabs.styled";
import ValidationModal from "../../components/Dashboard.modal/ValidationModal";
// import General from "../../stores/GeneralStore";

// import '../../App.scss'
import "../../components/footer/footer.scss";
import ConsentModal from "./ConsentModal";
import InformationModal from "./InformationModal";

function TabPanel(props: TabPanelProps) {
  const { children, value, index, padding = 0, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3, padding: padding }}>
          <Typography>{children}</Typography>
        </Box>
      )}
      {index == 7 && <Box sx={{ p: 3, padding: padding, height: "5vh" }}></Box>}
    </div>
  );
}

export default observer(function MainTabs({
  profileSet,
  leaveProfile,
  notification,
  handleNotificationFalse,
}: {
  profileSet: boolean;
  leaveProfile: () => void;
  notification: Boolean;
  handleNotificationFalse: any;
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const [value, setValue] = React.useState<any>(0);
  const [innerValue, setInnerValue] = React.useState<any>(0);
  const [nocTab, setNocTab] = React.useState(0);
  const [autoPayModal, setAutoPayModal] = React.useState(false);
  const [informationModal, setInformationModal] = React.useState(false);
  const [gdprModal, setGdprModal] = React.useState(false);
  const [gdpMatter, setGdpMatter] = React.useState<string>("");
  const [poBoxData, setPoBoxData] = React.useState<any>([]);
  const [openModal, setOpenModal] = React.useState(false);
  const [userPolicyVersion, setUserPolicyVersion] = React.useState<
    number | null
  >(null);
  const [serverPolicyVersion, setServerPolicyVersion] = React.useState<
    number | null
  >(null);
  const [showProfileModal, setShowProfileModal] = React.useState(false);
  const [showContent, setShowContent] = React.useState(true);

  // console.log("value", value);
  const handleOpenAutoPayModal = () => {
    setAutoPayModal(true);
  };
  
  const validateProfile = async () => {
      // const details = await User.getProfile(User.info.personId);
      console.log("profile in tabs", User.profile);
      if ((!User?.profile?.email || User?.profile?.email =="NA") || (!User?.profile?.mobileNumber || User?.profile?.mobileNumber =="NA")) {
        setShowContent(false);
       if(!User.isPopUpOpen){
        setShowProfileModal(true);
        User.isPopUpOpen = true;
       }
      }
      else{
        setShowContent(true);
        setShowProfileModal(false);
      }
    };
  useEffect(() => {
    if(User?.profile?.personId){
       validateProfile();

    }
  }, [User.profile]);

  useEffect(() => {
    if (notification) {
      setValue(5);
    }
  }, [notification]);
  const handleCloseAutoPayModal = () => {
    setAutoPayModal(false);
  };
  const hashLoc = location.hash;
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    if (hashLoc) {
      navigate("/dashboard");
      localStorage.removeItem("hash");
    }
    handleNotificationFalse();
    setValue(newValue);
    setInnerValue(0);
    setNocTab(0);
    leaveProfile();
  };

  const handleAutoPay = () => {
    setValue(7);
  };

  const viewAll = (index: number) => {
    if (index == 2) setNocTab(1);
    if (index == 6) {
      setNocTab(0);
      setValue(2);
      return;
    }
    setValue(index);
  };
  const setByHas = (hash: any) => {
    if (hash == "billpayment") {
      setValue(1);
    } else if (hash == "billenquiry") {
      setValue(1);
      setInnerValue(1);
    }
  };
  useEffect(() => {
    // if (!User.info.personId) navigate("/");
    const hash = localStorage.getItem("hash");
    setByHas(hash);
    if (hashLoc) {
      const hashValue = hashLoc.substring(1); // Remove the '#' symbol
      setByHas(hashValue);
    }
  }, [hashLoc]);

  useEffect(() => {
    if (profileSet) setValue(6);
  }, [profileSet]);

  const [isLargeScreen, setIsLargeScreen] = React.useState(false);
  const loadPoboxDetails = async () => {
    const res = await User.getPoboxData({
      errorId: "getBankDataError",
      data: User.info.personId,
    });
    await User.getProfile(User.info.personId)
    if (res?.city == null || res?.state == null) {
      setInformationModal(true);
    }
    setPoBoxData(res);
  };
  const loadBankDetails = async () => {
    await User.getBankData({
      errorId: "getBankDataError",
      data: User.info.personId,
    });
  };
  useEffect(() => {
    loadPoboxDetails();
    loadBankDetails();
    function handleResize() {
      setIsLargeScreen(window.innerWidth > 991);
    }
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  // for getting text value
  const [notificationInterval, setNotificarionInterval] = React.useState();
  const getNotificationConfig = async () => {
    await General?.getNotificationConfig({ errorId: "getNotificationConfig" });
    setNotificarionInterval(
      General?.notificationConfig?.notificationTimeInterval
    );
  };
  const [notificationCount, setNotificationCount] = React.useState<any>();
  const getNotificationCount = async () => {
    const countNotification: any = await General.getNotificationsCount({
      errorId: "getNotificationsCountError",
    });
    setNotificationCount(countNotification);
  };
  const setColorContrastClass = (
    valueID: number,
    textClass: string,
    contrastColor: string
  ) => {
    return textClass === null
      ? value === valueID // null
        ? contrastColor === "" || typeof contrastColor === "undefined"
          ? "darkBlueText"
          : contrastColor === "yellow"
          ? "yellowText"
          : "limeText" //active tab
        : contrastColor === "" || typeof contrastColor === "undefined"
        ? "whiteText"
        : contrastColor === "yellow"
        ? "blueText"
        : "blackText" // non active tab
      : value === valueID // !null
      ? contrastColor === "" || typeof contrastColor === "undefined"
        ? textClass
        : contrastColor === "yellow"
        ? "yellowText"
        : "limeText" //active tab
      : contrastColor === "" || typeof contrastColor === "undefined"
      ? "whiteText"
      : contrastColor === "yellow"
      ? "blueText"
      : "blackText"; // non active tab
  };

  useEffect(() => {
    getNotificationConfig();
    getNotificationCount();
    const intervalId = setInterval(() => {
      getNotificationCount();
    }, Number(notificationInterval ? notificationInterval : 30) * 60 * 1000); // 2 minutes in milliseconds

    // Clean up the interval when the component is unmounted or dependencies change
    return () => clearInterval(intervalId);
  }, []);
  const ColorAss = General?.ColorAss;
  const contrast = General?.contrast;
  useEffect(() => {
    General?.handleBackClick();
    if (location.state && location.state.fromRefund) {
      setValue(4);
    } else if (location.state && location.state.paymentPlan) {
      setValue(2);
      setNocTab(2);
    } else if (location.state && location.state.autoPay) {
      setValue(7);
    }
  }, [location]);

  useEffect(() => {
    //console.log("Contrast: ", contrast);
  }, [contrast]);
  // useEffect(() => {
  //   console.log("poBoxdata set with", poBoxData);
  //   gdprConsent(poBoxData);
  // }, [poBoxData])

  useEffect(() => {
    const fetchPolicyData = async () => {
      try {
        if (!poBoxData || Object.keys(poBoxData).length === 0) return;

        // Fetch User Policy Versions
        const userPolicyVersionList =
          poBoxData?.personCharacteristic?.filter(
            (item: any) => item.characteristicType === "CMDATCON"
          ) ?? [];

        // Sort Policy Versions in Descending Order (Latest First)
        const sortedPolicyVersionList = userPolicyVersionList.sort(
          (a: any, b: any) =>
            new Date(b.effectiveDate).getTime() -
            new Date(a.effectiveDate).getTime()
        );

        // Get Latest User Policy Version
        const latestUserPolicy = sortedPolicyVersionList.length
          ? parseFloat(sortedPolicyVersionList[0].adhocCharacteristicValue) ||
            null
          : null;

        // Get Server Policy Version
        const serverPolicyResponse = await User.getServerPolicyVersion({
          errorId: "getServerPolicyVersionError",
        });
        const latestServerPolicy = parseFloat(serverPolicyResponse?.result);
        console.log("latestUserPolicy==>", latestUserPolicy);
        console.log("latestServerPolicy==>", latestServerPolicy);
        // Check if GDPR consent needed
        const hasNoUserPolicy = latestUserPolicy === null;
        if (
          (hasNoUserPolicy || latestUserPolicy < latestServerPolicy) &&
          latestUserPolicy != 0
        ) {
          const gdprConsentMatter = await User.getConsentHtml({
            errorId: "getConsentHtmlError",
            data: "CSS_LOGIN",
          });
          setGdpMatter(gdprConsentMatter.result);
          setOpenModal(true);
          setGdprModal(true);
        } else {
          setGdprModal(false);
          setOpenModal(false);
        }
      } catch (error) {
        console.error("Error fetching policy data:", error);
      }
    };

    fetchPolicyData();
  }, [poBoxData]);

  return (
    <>
      {showProfileModal && (
        <ValidationModal
          onClose={() => {
            setShowProfileModal(false);
          }}
          setValue={setValue}
        />
      )}

      {gdprModal && (
        <ConsentModal gdpMatter={gdpMatter} openState={openModal} />
      )}
      <Box
        sx={{
          width: "100%",
          paddingTop: ".8rem",
          paddingBottom: "4rem",
          backgroundColor: contrast?.contrastBackground
            ? contrast?.contrastBackground
            : "",
          color: contrast?.contrastColor ? contrast?.contrastColor : "#101e8e",
          // '--bg-color': ColorAss ? ColorAss : 'pink',
        }}
      >
        <Box
          sx={{
            borderBottom: isLargeScreen ? 1 : 0,
            display: "flex",
            background: contrast?.contrastBackground
              ? contrast?.contrastBackground
              : "#eee",
            width: isLargeScreen ? "95%" : "100%",
            margin: "auto",
            alignItems: "center",
            border: "none",
            marginTop: isLargeScreen ? "" : "4rem",
          }}
        >
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
            sx={{
              alignSelf: "flex-end",
              width: isLargeScreen ? "100%" : "100%",
            }}
            variant="scrollable"
            //remove border bottom //
            TabIndicatorProps={{
              style: {
                display: "none",
              },
            }}
            scrollButtons
            allowScrollButtonsMobile
          >
            <Tab
              disabled={!showContent}
              className={`${
                value !== 0 ? General?.contrast?.contrastColor : "slctd"
              } 
            ${
              value === 0
                ? General.contrast.contrastColor
                  ? General.contrast.contrastColor === "yellow"
                    ? "slctd-yellow"
                    : "slctd-black"
                  : "slctd"
                : ""
            } tab-width`}
              sx={{
                borderTop: `7px solid ${
                  General.contrast.contrastColor
                    ? General.contrast.contrastColor
                    : ColorAss || "#101E8E"
                } !important`,
                margin: "0.2rem",
                marginBottom: "0",
                // width: "18%",
                marginRight: isLargeScreen ? "0.75rem" : "0",
                zIndex: "0",
                color: "#fff",
                background: contrast?.contrastColor
                  ? contrast?.contrastColor
                  : ColorAss,
                width: "15%",
                opacity: !showContent ? 0.5 : 1,
                cursor: !showContent ? "not-allowed" : "pointer",
              }}
              label={
                <TabWithCount
                  isLargeScreen={isLargeScreen}
                  justifyContent="center"
                >
                  <svg
                    viewBox="0 0 27 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M13.1385 4.2147e-05C13.1059 0.000614754 13.0734 0.00397427 13.0414 0.0100839C10.7283 0.0284889 8.55873 0.646718 6.67712 1.71496C6.60568 1.73898 6.5397 1.7769 6.48298 1.82654C4.56556 2.95877 2.96145 4.56368 1.82916 6.48036C1.77781 6.5381 1.73872 6.60567 1.71424 6.67896C0.647171 8.55944 0.0298378 10.7267 0.0104755 13.0354C-0.00420703 13.111 -0.00344797 13.1888 0.012707 13.2642C0.0379705 16.1208 0.974505 18.7659 2.54882 20.9116C2.6696 21.0762 2.86904 21.1639 3.07201 21.1416C3.27497 21.1193 3.45063 20.9904 3.53281 20.8035C3.615 20.6166 3.59122 20.4 3.47044 20.2354C3.33957 20.057 3.21844 19.871 3.09754 19.6852L3.09108 19.6753L4.0908 19.0884C4.31382 18.9616 4.42495 18.7016 4.36255 18.4528C4.30014 18.2039 4.07949 18.0272 3.82302 18.0206C3.71348 18.0177 3.60542 18.0464 3.51172 18.1032L2.50977 18.6923C1.72596 17.1934 1.25845 15.5072 1.17421 13.7183H2.29331C2.49933 13.7212 2.69096 13.6129 2.79482 13.435C2.89868 13.257 2.89868 13.037 2.79482 12.859C2.69096 12.6811 2.49933 12.5728 2.29331 12.5757H1.16528C1.248 10.8049 1.71978 9.14013 2.48745 7.6519L3.46151 8.21424C3.63862 8.32618 3.86279 8.33219 4.04565 8.22991C4.2285 8.12763 4.34071 7.93347 4.33802 7.72397C4.33534 7.51447 4.21819 7.32324 4.03278 7.22568L3.05872 6.66334C3.98846 5.21808 5.2182 3.98838 6.66373 3.05833L7.22607 4.03239C7.32363 4.2178 7.51486 4.33494 7.72436 4.33763C7.93386 4.34031 8.12802 4.22811 8.2303 4.04526C8.33258 3.8624 8.32657 3.63823 8.21463 3.46112L7.65229 2.48706C9.1396 1.7199 10.8048 1.24767 12.5761 1.16489V2.29292C12.5732 2.49894 12.6815 2.69057 12.8594 2.79443C13.0373 2.89829 13.2574 2.89829 13.4354 2.79443C13.6133 2.69057 13.7216 2.49894 13.7187 2.29292V1.16489C15.4902 1.24763 17.1551 1.72008 18.6425 2.48706L18.0802 3.46112C17.9682 3.63823 17.9622 3.8624 18.0645 4.04526C18.1668 4.22811 18.3609 4.34031 18.5704 4.33763C18.7799 4.33494 18.9712 4.2178 19.0687 4.03239L19.6311 3.05833C21.0769 3.98825 22.3063 5.21774 23.2361 6.66334L22.262 7.22568C22.0766 7.32324 21.9594 7.51447 21.9568 7.72397C21.9541 7.93347 22.0663 8.12763 22.2491 8.22991C22.432 8.33219 22.6562 8.32618 22.8333 8.21424L23.8073 7.6519C24.5744 9.13975 25.0468 10.8048 25.1295 12.5757H24.0015C23.7955 12.5728 23.6038 12.6811 23.5 12.859C23.3961 13.037 23.3961 13.257 23.5 13.435C23.6038 13.6129 23.7955 13.7212 24.0015 13.7183H25.1206C25.0363 15.5072 24.5688 17.1934 23.785 18.6923L22.7831 18.1032C22.7011 18.0533 22.6078 18.0249 22.5119 18.0206C22.493 18.0197 22.474 18.0197 22.455 18.0206C22.2015 18.0341 21.9873 18.2132 21.9292 18.4604C21.871 18.7075 21.983 18.9634 22.204 19.0884L23.2037 19.6753L23.1972 19.6853L23.1971 19.6854L23.1971 19.6855C23.0762 19.8711 22.9552 20.0571 22.8243 20.2354C22.7035 20.4 22.6797 20.6166 22.7619 20.8035C22.8441 20.9905 23.0198 21.1194 23.2228 21.1416C23.4257 21.1639 23.6252 21.0762 23.746 20.9116C25.3197 18.7668 26.2561 16.1229 26.2821 13.2675C26.2978 13.1933 26.2985 13.1167 26.2843 13.0421C26.2661 10.7266 25.6469 8.55417 24.5761 6.67003L24.575 6.6678C24.5516 6.60336 24.5168 6.54364 24.4723 6.49151C23.339 4.56849 21.7313 2.95864 19.8085 1.8243C19.808 1.82405 19.8077 1.82362 19.8073 1.82319L19.8069 1.82262L19.8062 1.82207C19.7516 1.77582 19.6888 1.74024 19.621 1.71719C17.7389 0.648187 15.5686 0.028681 13.2545 0.0100839H13.2523C13.2148 0.00294249 13.1766 -0.000421589 13.1385 4.2147e-05ZM21.0168 8.37268L14.705 10.7604C14.2559 10.4657 13.7218 10.2907 13.1474 10.2907C11.5756 10.2907 10.2911 11.5771 10.2911 13.147C10.2911 14.7169 11.5756 16.0033 13.1474 16.0033C14.7191 16.0033 16.0037 14.7169 16.0037 13.147C16.0037 13.1378 16.0032 13.1288 16.0026 13.1198C16.0021 13.1122 16.0016 13.1045 16.0015 13.0968L21.1451 8.57686L21.0168 8.37268ZM14.8612 13.147C14.8612 12.1935 14.102 11.4332 13.1474 11.4332C12.193 11.4332 11.4336 12.1942 11.4336 13.147C11.4336 14.0998 12.193 14.8608 13.1474 14.8608C14.1018 14.8608 14.8612 14.0998 14.8612 13.147ZM7.4336 20.5735C7.11811 20.5735 6.86237 20.8293 6.86234 21.1447V23.4287C6.86237 23.7442 7.11811 23.9999 7.4336 24H18.8612C19.1767 23.9999 19.4324 23.7442 19.4324 23.4287V21.1447C19.4324 20.8293 19.1767 20.5735 18.8612 20.5735H7.4336ZM18.2899 22.8574V21.716H8.00487V22.8574H18.2899Z"
                      fill={
                        value === 0
                          ? General.contrast.contrastColor
                            ? General.contrast.contrastColor
                            : ColorAss || "#101E8E"
                          : General.contrast.contrastBackground
                          ? General.contrast.contrastBackground
                          : "white"
                      }
                    />
                  </svg>
                  {/* Dashboard */}
                  <span
                    style={{
                      fontSize: `${
                        isLargeScreen
                          ? 0.875
                          : 0.6 * General.accessibility.fontSize
                      }rem`,
                    }}
                    className={setColorContrastClass(
                      0,
                      General?.textClass,
                      General.contrast.contrastColor
                    )}
                  >
                    {General?.codeLabels["cm_dashboard"]?.label !== undefined
                      ? General?.codeLabels["cm_dashboard"]?.label.toLowerCase()
                      : "Dashboard"}
                  </span>
                </TabWithCount>
              }
              {...a11yProps(0)}
            />
            <Tab
              disabled={!showContent}
              className={`${value !== 1 ? General?.colorClass : "slctd"} 
             ${
               value === 1
                 ? General.contrast.contrastColor
                   ? General.contrast.contrastColor === "yellow"
                     ? "slctd-yellow"
                     : "slctd-black"
                   : "slctd"
                 : ""
             } tab-width`}
              sx={{
                color: contrast?.contrastBackground
                  ? contrast?.contrastBackground
                  : "#fff",
                background: contrast?.contrastColor
                  ? contrast?.contrastColor
                  : ColorAss,
                borderTop: `7px solid  ${
                  General.contrast.contrastColor
                    ? General.contrast.contrastColor
                    : ColorAss || "#101E8E"
                } !important`,
                margin: "0.2rem",
                marginBottom: "0",
                // width: "18%",
                marginRight: isLargeScreen ? "0.75rem" : "0",
                zIndex: "0",
                width: "15%",
                opacity: !showContent ? 0.5 : 1,
                cursor: !showContent ? "not-allowed" : "pointer",
              }}
              label={
                <TabWithCount
                  isLargeScreen={isLargeScreen}
                  justifyContent="center"
                >
                  <svg
                    width="32"
                    height="24"
                    viewBox="0 0 32 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M0 2.22222C0 1 1 0 2.22222 0H25.3333C26.5556 0 27.5556 1 27.5556 2.22222V6.22222H28.8889C30.1111 6.22222 31.1111 7.22222 31.1111 8.44444V21.7778C31.1111 23 30.1111 24 28.8889 24H6.66667C5.44444 24 4.44444 23 4.44444 21.7778V18.6667H2.22222C1 18.6667 0 17.6667 0 16.4444V2.22222ZM25.3333 0.888889H2.22222C1.4809 0.888889 0.888889 1.4809 0.888889 2.22222V3.55556H26.6667V2.22222C26.6667 1.4809 26.0747 0.888889 25.3333 0.888889ZM0.888889 5.33333H26.6667V16.4444C26.6667 17.1858 26.0747 17.7778 25.3333 17.7778H2.22222C1.4809 17.7778 0.888889 17.1858 0.888889 16.4444V5.33333ZM28.8889 7.11111H27.5556V9.77778H30.2222V8.44444C30.2222 7.70312 29.6302 7.11111 28.8889 7.11111ZM2.66667 8.44444C2.42188 8.44444 2.22222 8.6441 2.22222 8.88889C2.22222 9.13368 2.42188 9.33333 2.66667 9.33333C2.91146 9.33333 3.11111 9.13368 3.11111 8.88889C3.11111 8.6441 2.91146 8.44444 2.66667 8.44444ZM4 8.88889C4 8.6441 4.19965 8.44444 4.44444 8.44444C4.68924 8.44444 4.88889 8.6441 4.88889 8.88889C4.88889 9.13368 4.68924 9.33333 4.44444 9.33333C4.19965 9.33333 4 9.13368 4 8.88889ZM6.22222 8.44444C5.97743 8.44444 5.77778 8.6441 5.77778 8.88889C5.77778 9.13368 5.97743 9.33333 6.22222 9.33333C6.46701 9.33333 6.66667 9.13368 6.66667 8.88889C6.66667 8.6441 6.46701 8.44444 6.22222 8.44444ZM7.55556 8.88889C7.55556 8.6441 7.75521 8.44444 8 8.44444C8.24479 8.44444 8.44444 8.6441 8.44444 8.88889C8.44444 9.13368 8.24479 9.33333 8 9.33333C7.75521 9.33333 7.55556 9.13368 7.55556 8.88889ZM9.77778 8.44444C9.53299 8.44444 9.33333 8.6441 9.33333 8.88889C9.33333 9.13368 9.53299 9.33333 9.77778 9.33333C10.0226 9.33333 10.2222 9.13368 10.2222 8.88889C10.2222 8.6441 10.0226 8.44444 9.77778 8.44444ZM11.1111 8.88889C11.1111 8.6441 11.3108 8.44444 11.5556 8.44444C11.8003 8.44444 12 8.6441 12 8.88889C12 9.13368 11.8003 9.33333 11.5556 9.33333C11.3108 9.33333 11.1111 9.13368 11.1111 8.88889ZM13.3333 8.44444C13.0885 8.44444 12.8889 8.6441 12.8889 8.88889C12.8889 9.13368 13.0885 9.33333 13.3333 9.33333C13.5781 9.33333 13.7778 9.13368 13.7778 8.88889C13.7778 8.6441 13.5781 8.44444 13.3333 8.44444ZM30.2222 21.7778V11.5556H27.5556V16.4444C27.5556 17.6667 26.5556 18.6667 25.3333 18.6667H5.33333V21.7778C5.33333 22.5191 5.92535 23.1111 6.66667 23.1111H28.8889C29.6302 23.1111 30.2222 22.5191 30.2222 21.7778ZM2.66667 15.5556C2.42188 15.5556 2.22222 15.7552 2.22222 16C2.22222 16.2448 2.42188 16.4444 2.66667 16.4444C2.91146 16.4444 3.11111 16.2448 3.11111 16C3.11111 15.7552 2.91146 15.5556 2.66667 15.5556ZM4 16C4 15.7552 4.19965 15.5556 4.44444 15.5556C4.68924 15.5556 4.88889 15.7552 4.88889 16C4.88889 16.2448 4.68924 16.4444 4.44444 16.4444C4.19965 16.4444 4 16.2448 4 16ZM6.22222 15.5556C5.97743 15.5556 5.77778 15.7552 5.77778 16C5.77778 16.2448 5.97743 16.4444 6.22222 16.4444C6.46701 16.4444 6.66667 16.2448 6.66667 16C6.66667 15.7552 6.46701 15.5556 6.22222 15.5556ZM7.55556 16C7.55556 15.7552 7.75521 15.5556 8 15.5556C8.24479 15.5556 8.44444 15.7552 8.44444 16C8.44444 16.2448 8.24479 16.4444 8 16.4444C7.75521 16.4444 7.55556 16.2448 7.55556 16ZM9.77778 15.5556C9.53299 15.5556 9.33333 15.7552 9.33333 16C9.33333 16.2448 9.53299 16.4444 9.77778 16.4444C10.0226 16.4444 10.2222 16.2448 10.2222 16C10.2222 15.7552 10.0226 15.5556 9.77778 15.5556ZM11.1111 16C11.1111 15.7552 11.3108 15.5556 11.5556 15.5556C11.8003 15.5556 12 15.7552 12 16C12 16.2448 11.8003 16.4444 11.5556 16.4444C11.3108 16.4444 11.1111 16.2448 11.1111 16ZM13.3333 15.5556C13.0885 15.5556 12.8889 15.7552 12.8889 16C12.8889 16.2448 13.0885 16.4444 13.3333 16.4444C13.5781 16.4444 13.7778 16.2448 13.7778 16C13.7778 15.7552 13.5781 15.5556 13.3333 15.5556ZM14.6667 16C14.6667 15.7552 14.8663 15.5556 15.1111 15.5556C15.3559 15.5556 15.5556 15.7552 15.5556 16C15.5556 16.2448 15.3559 16.4444 15.1111 16.4444C14.8663 16.4444 14.6667 16.2448 14.6667 16ZM16.8889 15.5556C16.6441 15.5556 16.4444 15.7552 16.4444 16C16.4444 16.2448 16.6441 16.4444 16.8889 16.4444C17.1337 16.4444 17.3333 16.2448 17.3333 16C17.3333 15.7552 17.1337 15.5556 16.8889 15.5556ZM18.2222 16C18.2222 15.7552 18.4219 15.5556 18.6667 15.5556C18.9115 15.5556 19.1111 15.7552 19.1111 16C19.1111 16.2448 18.9115 16.4444 18.6667 16.4444C18.4219 16.4444 18.2222 16.2448 18.2222 16ZM20.4444 15.5556C20.1997 15.5556 20 15.7552 20 16C20 16.2448 20.1997 16.4444 20.4444 16.4444C20.6892 16.4444 20.8889 16.2448 20.8889 16C20.8889 15.7552 20.6892 15.5556 20.4444 15.5556ZM21.7778 16C21.7778 15.7552 21.9774 15.5556 22.2222 15.5556C22.467 15.5556 22.6667 15.7552 22.6667 16C22.6667 16.2448 22.467 16.4444 22.2222 16.4444C21.9774 16.4444 21.7778 16.2448 21.7778 16ZM24 15.5556C23.7552 15.5556 23.5556 15.7552 23.5556 16C23.5556 16.2448 23.7552 16.4444 24 16.4444C24.2448 16.4444 24.4444 16.2448 24.4444 16C24.4444 15.7552 24.2448 15.5556 24 15.5556ZM6.66667 21.3333C6.66667 21.0885 6.86632 20.8889 7.11111 20.8889C7.3559 20.8889 7.55556 21.0885 7.55556 21.3333C7.55556 21.5781 7.3559 21.7778 7.11111 21.7778C6.86632 21.7778 6.66667 21.5781 6.66667 21.3333ZM8.88889 20.8889C8.6441 20.8889 8.44444 21.0885 8.44444 21.3333C8.44444 21.5781 8.6441 21.7778 8.88889 21.7778C9.13368 21.7778 9.33333 21.5781 9.33333 21.3333C9.33333 21.0885 9.13368 20.8889 8.88889 20.8889ZM10.2222 21.3333C10.2222 21.0885 10.4219 20.8889 10.6667 20.8889C10.9115 20.8889 11.1111 21.0885 11.1111 21.3333C11.1111 21.5781 10.9115 21.7778 10.6667 21.7778C10.4219 21.7778 10.2222 21.5781 10.2222 21.3333ZM12.4444 20.8889C12.1997 20.8889 12 21.0885 12 21.3333C12 21.5781 12.1997 21.7778 12.4444 21.7778C12.6892 21.7778 12.8889 21.5781 12.8889 21.3333C12.8889 21.0885 12.6892 20.8889 12.4444 20.8889ZM13.7778 21.3333C13.7778 21.0885 13.9774 20.8889 14.2222 20.8889C14.467 20.8889 14.6667 21.0885 14.6667 21.3333C14.6667 21.5781 14.467 21.7778 14.2222 21.7778C13.9774 21.7778 13.7778 21.5781 13.7778 21.3333ZM16 20.8889C15.7552 20.8889 15.5556 21.0885 15.5556 21.3333C15.5556 21.5781 15.7552 21.7778 16 21.7778C16.2448 21.7778 16.4444 21.5781 16.4444 21.3333C16.4444 21.0885 16.2448 20.8889 16 20.8889ZM17.3333 21.3333C17.3333 21.0885 17.533 20.8889 17.7778 20.8889C18.0226 20.8889 18.2222 21.0885 18.2222 21.3333C18.2222 21.5781 18.0226 21.7778 17.7778 21.7778C17.533 21.7778 17.3333 21.5781 17.3333 21.3333ZM19.5556 20.8889C19.3108 20.8889 19.1111 21.0885 19.1111 21.3333C19.1111 21.5781 19.3108 21.7778 19.5556 21.7778C19.8003 21.7778 20 21.5781 20 21.3333C20 21.0885 19.8003 20.8889 19.5556 20.8889ZM20.8889 21.3333C20.8889 21.0885 21.0885 20.8889 21.3333 20.8889C21.5781 20.8889 21.7778 21.0885 21.7778 21.3333C21.7778 21.5781 21.5781 21.7778 21.3333 21.7778C21.0885 21.7778 20.8889 21.5781 20.8889 21.3333ZM23.1111 20.8889C22.8663 20.8889 22.6667 21.0885 22.6667 21.3333C22.6667 21.5781 22.8663 21.7778 23.1111 21.7778C23.3559 21.7778 23.5556 21.5781 23.5556 21.3333C23.5556 21.0885 23.3559 20.8889 23.1111 20.8889ZM24.4444 21.3333C24.4444 21.0885 24.6441 20.8889 24.8889 20.8889C25.1337 20.8889 25.3333 21.0885 25.3333 21.3333C25.3333 21.5781 25.1337 21.7778 24.8889 21.7778C24.6441 21.7778 24.4444 21.5781 24.4444 21.3333ZM26.6667 20.8889C26.4219 20.8889 26.2222 21.0885 26.2222 21.3333C26.2222 21.5781 26.4219 21.7778 26.6667 21.7778C26.9115 21.7778 27.1111 21.5781 27.1111 21.3333C27.1111 21.0885 26.9115 20.8889 26.6667 20.8889ZM28 21.3333C28 21.0885 28.1997 20.8889 28.4444 20.8889C28.6892 20.8889 28.8889 21.0885 28.8889 21.3333C28.8889 21.5781 28.6892 21.7778 28.4444 21.7778C28.1997 21.7778 28 21.5781 28 21.3333Z"
                      fill={
                        value === 1
                          ? General.contrast.contrastColor
                            ? General.contrast.contrastColor
                            : ColorAss || "#101E8E"
                          : General.contrast.contrastBackground
                          ? General.contrast.contrastBackground
                          : "white"
                      }
                    />
                  </svg>
                  <span
                    style={{
                      fontSize: `${
                        isLargeScreen
                          ? 0.875
                          : 0.5 * General.accessibility.fontSize
                      }rem`,
                    }}
                    className={setColorContrastClass(
                      1,
                      General?.textClass,
                      General.contrast.contrastColor
                    )}
                  >
                    {General?.codeLabels["cm_payment_and_receipt"]?.label ??
                      "Payments & Receipts"}
                  </span>
                </TabWithCount>
              }
              {...a11yProps(1)}
            />
            <Tab
              disabled={!showContent}
              className={`${value !== 2 ? General?.colorClass : "slctd"} 
            ${
              value === 2
                ? General.contrast.contrastColor
                  ? General.contrast.contrastColor === "yellow"
                    ? "slctd-yellow"
                    : "slctd-black"
                  : "slctd"
                : ""
            } tab-width`}
              label={
                <TabWithCount
                  isLargeScreen={isLargeScreen}
                  justifyContent="center"
                >
                  <svg
                    width="26"
                    height="24"
                    viewBox="0 0 26 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M6.92288 0.000677139C6.82553 0.000677139 6.72818 0.0313252 6.64705 0.0926218L5.07678 1.26987L3.50651 0.0926218C3.36769 -0.0119428 3.1802 -0.0299709 3.02335 0.0493538C2.86831 0.128678 2.76915 0.287328 2.76915 0.462203V20.3078H1.8461C0.827501 20.3078 0 21.1353 0 22.1539C0 23.1725 0.827501 24 1.8461 24H23.9993C25.0179 24 25.8454 23.1725 25.8454 22.1539C25.8454 21.1353 25.0179 20.3078 23.9993 20.3078H23.0763V1.38525C23.0763 1.26266 23.0276 1.14548 22.9411 1.05894L22.018 0.13589C21.8558 -0.0263655 21.5979 -0.0461963 21.4159 0.0926218L19.8456 1.26987L18.2771 0.0926218C18.1131 -0.0299709 17.8859 -0.0299709 17.7237 0.0926218L16.1534 1.26987L14.5831 0.0926218C14.4209 -0.0317736 14.1937 -0.0299709 14.0315 0.0926218L12.4612 1.26987L10.8909 0.0926218C10.7287 -0.0299709 10.5015 -0.0299709 10.3393 0.0926218L8.76898 1.26987L7.19872 0.0926218C7.11759 0.0313252 7.02024 0.000677139 6.92288 0.000677139ZM6.92288 1.03911L8.49315 2.21636C8.65541 2.33895 8.88256 2.33895 9.04482 2.21636L10.6151 1.03911L12.1854 2.21636C12.3476 2.34076 12.5748 2.33895 12.737 2.21636L14.3073 1.03911L15.8776 2.21636C16.0398 2.34076 16.267 2.33895 16.4292 2.21636L17.9995 1.03911L19.5698 2.21636C19.732 2.33895 19.9592 2.33895 20.1214 2.21636L21.6484 1.07156L22.1532 1.57635V18.4617C21.899 18.4617 21.6917 18.669 21.6917 18.9232V19.8463C21.6917 20.1005 21.899 20.3078 22.1532 20.3078V23.077H3.6922V20.3078C3.9464 20.3078 4.15373 20.1005 4.15373 19.8463V18.9232C4.15373 18.669 3.9464 18.4617 3.6922 18.4617V1.38525L4.80095 2.21636C4.9632 2.33895 5.19036 2.33895 5.35261 2.21636L6.92288 1.03911ZM6.46136 5.07746C6.46136 4.82326 6.66868 4.61593 6.92288 4.61593H14.3073C14.5615 4.61593 14.7688 4.82326 14.7688 5.07746C14.7688 5.33166 14.5615 5.53898 14.3073 5.53898H6.92288C6.66868 5.53898 6.46136 5.33166 6.46136 5.07746ZM16.1534 4.61593C15.8992 4.61593 15.6919 4.82326 15.6919 5.07746C15.6919 5.33166 15.8992 5.53898 16.1534 5.53898H18.9225C19.1767 5.53898 19.3841 5.33166 19.3841 5.07746C19.3841 4.82326 19.1767 4.61593 18.9225 4.61593H16.1534ZM6.46136 6.92356C6.46136 6.66936 6.66868 6.46203 6.92288 6.46203H11.9997C12.2539 6.46203 12.4612 6.66936 12.4612 6.92356C12.4612 7.17776 12.2539 7.38508 11.9997 7.38508H6.92288C6.66868 7.38508 6.46136 7.17776 6.46136 6.92356ZM17.538 7.38508C17.2838 7.38508 17.0764 7.59241 17.0764 7.84661V8.30814C16.3138 8.30814 15.6919 8.93011 15.6919 9.69271V11.0773C15.6919 11.8399 16.3138 12.4619 17.0764 12.4619H17.9995C18.2537 12.4619 18.461 12.6692 18.461 12.9234V14.308C18.461 14.5622 18.2537 14.7695 17.9995 14.7695H17.0764C16.8222 14.7695 16.6149 14.5622 16.6149 14.308V13.8464C16.6149 13.5922 16.4076 13.3849 16.1534 13.3849C15.8992 13.3849 15.6919 13.5922 15.6919 13.8464V14.308C15.6919 15.0706 16.3138 15.6925 17.0764 15.6925V16.1541C17.0764 16.4083 17.2838 16.6156 17.538 16.6156C17.7922 16.6156 17.9995 16.4083 17.9995 16.1541V15.6925C18.7621 15.6925 19.3841 15.0706 19.3841 14.308V12.9234C19.3841 12.1608 18.7621 11.5388 17.9995 11.5388H17.0764C16.8222 11.5388 16.6149 11.3315 16.6149 11.0773V9.69271C16.6149 9.43851 16.8222 9.23119 17.0764 9.23119H17.9995C18.2537 9.23119 18.461 9.43851 18.461 9.69271V10.1542C18.461 10.4084 18.6683 10.6158 18.9225 10.6158C19.1767 10.6158 19.3841 10.4084 19.3841 10.1542V9.69271C19.3841 8.93011 18.7621 8.30814 17.9995 8.30814V7.84661C17.9995 7.59241 17.7922 7.38508 17.538 7.38508ZM6.46136 10.6158C6.46136 10.3616 6.66868 10.1542 6.92288 10.1542H11.5381C11.7923 10.1542 11.9997 10.3616 11.9997 10.6158C11.9997 10.87 11.7923 11.0773 11.5381 11.0773H6.92288C6.66868 11.0773 6.46136 10.87 6.46136 10.6158ZM6.92288 12.0003C6.66868 12.0003 6.46136 12.2077 6.46136 12.4619C6.46136 12.7161 6.66868 12.9234 6.92288 12.9234H12.9227C13.1769 12.9234 13.3842 12.7161 13.3842 12.4619C13.3842 12.2077 13.1769 12.0003 12.9227 12.0003H6.92288ZM6.46136 14.308C6.46136 14.0538 6.66868 13.8464 6.92288 13.8464H8.76898C9.02318 13.8464 9.23051 14.0538 9.23051 14.308C9.23051 14.5622 9.02318 14.7695 8.76898 14.7695H6.92288C6.66868 14.7695 6.46136 14.5622 6.46136 14.308ZM10.6151 13.8464C10.3609 13.8464 10.1536 14.0538 10.1536 14.308C10.1536 14.5622 10.3609 14.7695 10.6151 14.7695H11.5381C11.7923 14.7695 11.9997 14.5622 11.9997 14.308C11.9997 14.0538 11.7923 13.8464 11.5381 13.8464H10.6151ZM5.53831 18.9232C5.53831 18.669 5.74563 18.4617 5.99983 18.4617C6.25403 18.4617 6.46136 18.669 6.46136 18.9232V19.8463C6.46136 20.1005 6.25403 20.3078 5.99983 20.3078C5.74563 20.3078 5.53831 20.1005 5.53831 19.8463V18.9232ZM8.30746 18.4617C8.05326 18.4617 7.84593 18.669 7.84593 18.9232V19.8463C7.84593 20.1005 8.05326 20.3078 8.30746 20.3078C8.56166 20.3078 8.76898 20.1005 8.76898 19.8463V18.9232C8.76898 18.669 8.56166 18.4617 8.30746 18.4617ZM10.1536 18.9232C10.1536 18.669 10.3609 18.4617 10.6151 18.4617C10.8693 18.4617 11.0766 18.669 11.0766 18.9232V19.8463C11.0766 20.1005 10.8693 20.3078 10.6151 20.3078C10.3609 20.3078 10.1536 20.1005 10.1536 19.8463V18.9232ZM12.9227 18.4617C12.6685 18.4617 12.4612 18.669 12.4612 18.9232V19.8463C12.4612 20.1005 12.6685 20.3078 12.9227 20.3078C13.1769 20.3078 13.3842 20.1005 13.3842 19.8463V18.9232C13.3842 18.669 13.1769 18.4617 12.9227 18.4617ZM14.7688 18.9232C14.7688 18.669 14.9761 18.4617 15.2303 18.4617C15.4845 18.4617 15.6919 18.669 15.6919 18.9232V19.8463C15.6919 20.1005 15.4845 20.3078 15.2303 20.3078C14.9761 20.3078 14.7688 20.1005 14.7688 19.8463V18.9232ZM17.538 18.4617C17.2838 18.4617 17.0764 18.669 17.0764 18.9232V19.8463C17.0764 20.1005 17.2838 20.3078 17.538 20.3078C17.7922 20.3078 17.9995 20.1005 17.9995 19.8463V18.9232C17.9995 18.669 17.7922 18.4617 17.538 18.4617ZM19.3841 18.9232C19.3841 18.669 19.5914 18.4617 19.8456 18.4617C20.0998 18.4617 20.3071 18.669 20.3071 18.9232V19.8463C20.3071 20.1005 20.0998 20.3078 19.8456 20.3078C19.5914 20.3078 19.3841 20.1005 19.3841 19.8463V18.9232ZM1.8461 21.2308H2.76915V23.077H1.8461C1.3377 23.077 0.923051 22.6623 0.923051 22.1539C0.923051 21.6455 1.3377 21.2308 1.8461 21.2308ZM23.9993 21.2308H23.0763V23.077H23.9993C24.5077 23.077 24.9224 22.6623 24.9224 22.1539C24.9224 21.6455 24.5077 21.2308 23.9993 21.2308Z"
                      fill={
                        value === 2
                          ? General.contrast.contrastColor
                            ? General.contrast.contrastColor
                            : ColorAss || "#101E8E"
                          : General.contrast.contrastBackground
                          ? General.contrast.contrastBackground
                          : "white"
                      }
                    />
                  </svg>
                  <span
                    style={{
                      fontSize: `${
                        isLargeScreen
                          ? 0.875
                          : 0.6 * General.accessibility.fontSize
                      }rem`,
                    }}
                    className={setColorContrastClass(
                      2,
                      General?.textClass,
                      General.contrast.contrastColor
                    )}
                  >
                    {General?.codeLabels["cm_noc_request"]?.label
                      ? General?.codeLabels["cm_noc_request"]?.label
                      : "NOCs & Requests"}
                  </span>
                </TabWithCount>
              }
              {...a11yProps(2)}
              sx={{
                color: contrast?.contrastBackground
                  ? contrast?.contrastBackground
                  : "#fff",
                background: contrast?.contrastColor
                  ? contrast?.contrastColor
                  : ColorAss,
                borderTop: `7px solid  ${
                  General.contrast.contrastColor
                    ? General.contrast.contrastColor
                    : ColorAss || "#101E8E"
                } !important`,
                margin: "0.2rem",
                marginBottom: "0",
                // width: "18%",
                marginRight: isLargeScreen ? "0.75rem" : "0",
                zIndex: "0",
                width: "15%",
                opacity: !showContent ? 0.5 : 1,
                cursor: !showContent ? "not-allowed" : "pointer",
              }}
            />
            <Tab
              disabled={!showContent}
              className={`${value !== 3 ? General?.colorClass : "slctd"} 
            ${
              value === 3
                ? General.contrast.contrastColor
                  ? General.contrast.contrastColor === "yellow"
                    ? "slctd-yellow"
                    : "slctd-black"
                  : "slctd"
                : ""
            } tab-width`}
              label={
                <TabWithCount
                  isLargeScreen={isLargeScreen}
                  justifyContent="center"
                >
                  <svg
                    width="32"
                    height="24"
                    viewBox="0 0 32 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M1.5 0C0.673828 0 0 0.673828 0 1.5V22C0 23.1035 0.896484 24 2 24H26.3477C27.252 24 28.0469 23.3906 28.2812 22.5078L31.6777 8.86133C31.7891 8.41016 31.6895 7.94141 31.4043 7.57617C31.1172 7.21094 30.6855 7 30.2207 7H27V4.5C27 3.67383 26.3262 3 25.5 3H12.8535C12.4551 3 12.082 2.8457 11.7988 2.56641L9.93555 0.722656C9.46484 0.255859 8.83984 0 8.17773 0H1.5ZM1.5 1H8.17773C8.57617 1 8.94922 1.1543 9.23242 1.43359L11.0938 3.27539C11.5664 3.74219 12.1914 4 12.8535 4H25.5C25.7754 4 26 4.22461 26 4.5V7H8.25586C7.33398 7 6.53711 7.625 6.31445 8.51758L3.00586 21.8496C3.00391 21.8594 2.73047 23 2 23C1.44922 23 1 22.5508 1 22V1.5C1 1.22461 1.22461 1 1.5 1ZM30.2207 8H8.25586C7.79492 8 7.39648 8.3125 7.28516 8.75977L4.99219 18H22.5C22.7773 18 23 18.2227 23 18.5C23 18.7773 22.7773 19 22.5 19H4.74219L3.98047 22.0781C3.91992 22.3438 3.79883 22.6816 3.60547 23H26.3477C26.8008 23 27.1973 22.6953 27.3145 22.2578L30.7051 8.61914C30.7441 8.46875 30.7109 8.31445 30.6152 8.19336C30.5195 8.07031 30.377 8 30.2207 8ZM24.5 18C24.2227 18 24 18.2227 24 18.5C24 18.7773 24.2227 19 24.5 19H26.5C26.7773 19 27 18.7773 27 18.5C27 18.2227 26.7773 18 26.5 18H24.5ZM5.26562 20.3789C5.31445 20.1777 5.48047 20.0352 5.67188 20.0059C5.73633 19.9941 5.80469 19.998 5.87109 20.0156C6.13867 20.082 6.30273 20.3535 6.23438 20.6211L5.98438 21.6211C5.92773 21.8477 5.72461 22 5.5 22C5.46094 22 5.41992 21.9961 5.37891 21.9844C5.11133 21.918 4.94727 21.6465 5.01562 21.3789L5.26562 20.3789ZM8.17188 20.0059C7.98047 20.0352 7.81445 20.1777 7.76562 20.3789L7.51562 21.3789C7.44727 21.6465 7.61133 21.918 7.87891 21.9844C7.91992 21.9961 7.96094 22 8 22C8.22461 22 8.42773 21.8477 8.48438 21.6211L8.73438 20.6211C8.80273 20.3535 8.63867 20.082 8.37109 20.0156C8.30469 19.998 8.23633 19.9941 8.17188 20.0059ZM10.2656 20.3789C10.3145 20.1777 10.4805 20.0352 10.6719 20.0059C10.7363 19.9941 10.8047 19.998 10.8711 20.0156C11.1387 20.082 11.3027 20.3535 11.2344 20.6211L10.9844 21.6211C10.9277 21.8477 10.7246 22 10.5 22C10.4609 22 10.4199 21.9961 10.3789 21.9844C10.1113 21.918 9.94727 21.6465 10.0156 21.3789L10.2656 20.3789ZM13.1719 20.0059C12.9805 20.0352 12.8145 20.1777 12.7656 20.3789L12.5156 21.3789C12.4473 21.6465 12.6113 21.918 12.8789 21.9844C12.9199 21.9961 12.9609 22 13 22C13.2246 22 13.4277 21.8477 13.4844 21.6211L13.7344 20.6211C13.8027 20.3535 13.6387 20.082 13.3711 20.0156C13.3047 19.998 13.2363 19.9941 13.1719 20.0059ZM15.2656 20.3789C15.3145 20.1777 15.4805 20.0352 15.6719 20.0059C15.7363 19.9941 15.8047 19.998 15.8711 20.0156C16.1387 20.082 16.3027 20.3535 16.2344 20.6211L15.9844 21.6211C15.9277 21.8477 15.7246 22 15.5 22C15.4609 22 15.4199 21.9961 15.3789 21.9844C15.1113 21.918 14.9473 21.6465 15.0156 21.3789L15.2656 20.3789ZM18.1719 20.0059C17.9805 20.0352 17.8145 20.1777 17.7656 20.3789L17.5156 21.3789C17.4473 21.6465 17.6113 21.918 17.8789 21.9844C17.9199 21.9961 17.9609 22 18 22C18.2246 22 18.4277 21.8477 18.4844 21.6211L18.7344 20.6211C18.8027 20.3535 18.6387 20.082 18.3711 20.0156C18.3047 19.998 18.2363 19.9941 18.1719 20.0059ZM20.2656 20.3789C20.3145 20.1777 20.4805 20.0352 20.6719 20.0059C20.7363 19.9941 20.8047 19.998 20.8711 20.0156C21.1387 20.082 21.3027 20.3535 21.2344 20.6211L20.9844 21.6211C20.9277 21.8477 20.7246 22 20.5 22C20.4609 22 20.4199 21.9961 20.3789 21.9844C20.1113 21.918 19.9473 21.6465 20.0156 21.3789L20.2656 20.3789ZM23.1719 20.0059C22.9785 20.0352 22.8145 20.1777 22.7656 20.3789L22.5156 21.3789C22.4473 21.6465 22.6113 21.918 22.8789 21.9844C22.9199 21.9961 22.9609 22 23 22C23.2246 22 23.4277 21.8477 23.4844 21.6211L23.7344 20.6211C23.8027 20.3535 23.6387 20.082 23.3711 20.0156C23.3047 19.998 23.2363 19.9941 23.1719 20.0059ZM25.2656 20.3789C25.3145 20.1777 25.4805 20.0352 25.6719 20.0059C25.7363 19.9941 25.8047 19.998 25.8711 20.0156C26.1387 20.082 26.3027 20.3535 26.2344 20.6211L25.9844 21.6211C25.9277 21.8477 25.7246 22 25.5 22C25.4609 22 25.4199 21.9961 25.3789 21.9844C25.1113 21.918 24.9473 21.6465 25.0156 21.3789L25.2656 20.3789Z"
                      fill={
                        value === 3
                          ? General.contrast.contrastColor
                            ? General.contrast.contrastColor
                            : ColorAss || "#101E8E"
                          : General.contrast.contrastBackground
                          ? General.contrast.contrastBackground
                          : "white"
                      }
                    />
                  </svg>
                  <span
                    className={setColorContrastClass(
                      3,
                      General?.textClass,
                      General.contrast.contrastColor
                    )}
                    style={{
                      fontSize: `${
                        isLargeScreen
                          ? 0.875
                          : 0.7 * General.accessibility.fontSize
                      }rem`,
                    }}
                  >
                    {General?.codeLabels["cm_my_acc"]?.label
                      ? General?.codeLabels["cm_my_acc"]?.label
                      : "My Accounts"}
                  </span>
                </TabWithCount>
              }
              {...a11yProps(3)}
              sx={{
                color: contrast?.contrastBackground
                  ? contrast?.contrastBackground
                  : "#fff",
                background: contrast?.contrastColor
                  ? contrast?.contrastColor
                  : ColorAss,
                borderTop: `7px solid  ${
                  General.contrast.contrastColor
                    ? General.contrast.contrastColor
                    : ColorAss || "#101E8E"
                } !important`,
                margin: "0.2rem",
                marginBottom: "0",
                // width: "18%",
                marginRight: isLargeScreen ? "0.75rem" : "0",
                zIndex: "0",
                width: "15%",
                opacity: !showContent ? 0.5 : 1,
                cursor: !showContent ? "not-allowed" : "pointer",
              }}
            />
            <Tab
              disabled={!showContent}
              className={`${value !== 4 ? General?.colorClass : "slctd"} 
             ${
               value === 4
                 ? General.contrast.contrastColor
                   ? General.contrast.contrastColor === "yellow"
                     ? "slctd-yellow"
                     : "slctd-black"
                   : "slctd"
                 : ""
             } tab-width`}
              label={
                <TabWithCount
                  isLargeScreen={isLargeScreen}
                  justifyContent="center"
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M9.6445 0.00140617C9.42888 0.0257798 9.25639 0.192645 9.22452 0.406382L8.75955 3.27121C8.19895 3.43433 7.65899 3.64244 7.15464 3.91618L4.79978 2.23628C4.61041 2.09941 4.35168 2.12003 4.18481 2.28127L2.30992 4.15616C2.14868 4.32303 2.12806 4.58176 2.26493 4.77113L3.91483 7.14099C3.63547 7.65283 3.40674 8.18905 3.23987 8.76089L0.405036 9.22587C0.1688 9.26336 -0.00368981 9.46773 5.9973e-05 9.70584V12.3457C0.00380975 12.5744 0.166925 12.7675 0.390037 12.8107L3.25487 13.3206C3.42173 13.885 3.63735 14.4193 3.91483 14.9255L2.23493 17.2804C2.09806 17.4698 2.11869 17.7285 2.27993 17.8954L4.15482 19.7702C4.32168 19.9315 4.58042 19.9521 4.76978 19.8152L7.12464 18.1503C7.63461 18.4297 8.17646 18.6434 8.74455 18.8103L9.22452 21.6751C9.26202 21.9114 9.46638 22.0839 9.70449 22.0801H12.3443C12.3912 22.0764 12.4362 22.067 12.4793 22.0501V23.52C12.4793 23.7844 12.6949 24 12.9593 24H23.5187C23.783 24 23.9987 23.7844 23.9987 23.52V15.8405V15.7955V15.2855C23.9987 14.5374 23.3818 13.9206 22.6337 13.9206H18.614C18.6871 13.7219 18.7621 13.5137 18.824 13.3206L21.6738 12.8107C21.9044 12.775 22.075 12.5782 22.0788 12.3457V9.70584C22.0825 9.46773 21.91 9.26336 21.6738 9.22587L18.794 8.76089C18.629 8.20592 18.4059 7.67158 18.134 7.17099L19.8139 4.77113C19.9508 4.58176 19.9301 4.32303 19.7689 4.15616L17.894 2.28127C17.7271 2.12003 17.4684 2.09941 17.279 2.23628L14.9242 3.93118C14.4198 3.65369 13.8836 3.43808 13.3193 3.27121L12.8093 0.391383C12.7662 0.168271 12.5731 0.00515595 12.3443 0.00140617H9.70449C9.68387 -0.000468723 9.66512 -0.000468723 9.6445 0.00140617ZM10.1095 0.96135H11.9394L12.4193 3.69119C12.4531 3.87118 12.5862 4.01742 12.7643 4.06617C13.4655 4.24053 14.1274 4.52739 14.7292 4.89112C14.8923 4.99049 15.0986 4.98486 15.2542 4.87612L17.504 3.25622L18.794 4.54614L17.2041 6.82601C17.0897 6.97975 17.0784 7.18599 17.1741 7.35098C17.534 7.95094 17.8096 8.60153 17.984 9.30086C18.029 9.48835 18.1827 9.63084 18.374 9.66084L21.1188 10.1108V11.9407L18.374 12.4207C18.1827 12.4507 18.029 12.5932 17.984 12.7807C17.9278 13.0094 17.744 13.5175 17.594 13.9206H13.8442H13.8143C14.5717 13.1913 15.0442 12.1694 15.0442 11.0408C15.0442 8.83776 13.2424 7.03599 11.0394 7.03599C8.83642 7.03599 7.03465 8.83776 7.03465 11.0408C7.03465 13.2438 8.83642 15.0455 11.0394 15.0455C11.5906 15.0455 12.1212 14.933 12.5993 14.7305C12.5225 14.9012 12.4793 15.0868 12.4793 15.2855V15.7505C12.4775 15.7711 12.4775 15.7899 12.4793 15.8105V18.4653L11.9394 21.1202H10.1095L9.65949 18.4053C9.6295 18.2141 9.487 18.0603 9.29951 18.0154C8.59643 17.8429 7.92522 17.5691 7.31963 17.2054C7.15652 17.106 6.95028 17.1117 6.79466 17.2204L4.54479 18.7953L3.25487 17.5054L4.84478 15.2705C4.95352 15.1149 4.95914 14.9087 4.85978 14.7455C4.4923 14.1381 4.22419 13.4856 4.04982 12.7807C4.00483 12.5932 3.85108 12.4507 3.65985 12.4207L0.960004 11.9407V10.1108L3.65985 9.66084C3.85108 9.63084 4.00483 9.48835 4.04982 9.30086C4.22606 8.59215 4.50917 7.92844 4.87477 7.32098C4.97414 7.15786 4.96852 6.95162 4.85978 6.79601L3.26987 4.54614L4.57479 3.25622L6.80966 4.84612C6.9634 4.96049 7.16964 4.97174 7.33463 4.87612C7.93647 4.51427 8.59643 4.23866 9.29951 4.06617C9.487 4.02117 9.6295 3.86743 9.65949 3.67619L10.1095 0.96135ZM14.0842 11.0408C14.0842 9.35711 12.7231 7.99594 11.0394 7.99594C9.35576 7.99594 7.99459 9.35711 7.99459 11.0408C7.99459 12.7244 9.35576 14.0856 11.0394 14.0856C12.7231 14.0856 14.0842 12.7244 14.0842 11.0408ZM13.8442 14.8805H17.789C17.8809 14.9087 17.9821 14.9087 18.074 14.8805H22.6337C22.8643 14.8805 23.0387 15.0549 23.0387 15.2855V15.3605H13.4393V15.2855C13.4393 15.0549 13.6136 14.8805 13.8442 14.8805ZM23.0387 16.3204H13.4393V18.2853C13.4599 18.3641 13.4599 18.4466 13.4393 18.5253V23.0401H23.0387V16.3204ZM17.759 16.6054L17.414 16.9354L15.8091 18.5403L15.1942 18.0154L14.8342 17.7004L14.2042 18.4353L14.5642 18.7353L15.5241 19.5603L15.8691 19.8602L18.104 17.6254L18.434 17.2804L17.759 16.6054ZM17.414 19.3353L17.759 19.0053L18.434 19.6803L18.104 20.0252L15.8691 22.2601L15.5241 21.9601L14.5642 21.1352L14.2042 20.8352L14.8342 20.1002L15.1942 20.4152L15.8091 20.9402L17.414 19.3353Z"
                      fill={
                        value === 4
                          ? General.contrast.contrastColor
                            ? General.contrast.contrastColor
                            : ColorAss || "#101E8E"
                          : General.contrast.contrastBackground
                          ? General.contrast.contrastBackground
                          : "white"
                      }
                    />
                  </svg>
                  {/* Services */}
                  <span
                    className={setColorContrastClass(
                      4,
                      General?.textClass,
                      General.contrast.contrastColor
                    )}
                    style={{
                      fontSize: `${
                        isLargeScreen
                          ? 0.875
                          : 0.7 * General.accessibility.fontSize
                      }rem`,
                    }}
                  >
                    {General?.codeLabels["cm_services"]?.label !== undefined
                      ? General?.codeLabels["cm_services"]?.label
                      : "Services"}
                  </span>
                </TabWithCount>
              }
              {...a11yProps(4)}
              sx={{
                color: contrast?.contrastBackground
                  ? contrast?.contrastBackground
                  : "#fff",
                background: contrast?.contrastColor
                  ? contrast?.contrastColor
                  : ColorAss,
                borderTop: `7px solid  ${
                  General.contrast.contrastColor
                    ? General.contrast.contrastColor
                    : ColorAss || "#101E8E"
                } !important`,
                margin: "0.2rem",
                marginBottom: "0",
                // width: "18%",
                zIndex: "0",
                width: "15%",
                opacity: !showContent ? 0.5 : 1,
                cursor: !showContent ? "not-allowed" : "pointer",
              }}
            />
          </Tabs>
          {isLargeScreen ? (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <NotificationButton
                disabled={!showContent}
                style={{
                  display: "flex",
                  alignItems: "center",
                  backgroundColor: General.contrast.contrastColor
                    ? General.contrast.contrastColor
                    : General?.ColorAss,
                  color: contrast?.contrastColor
                    ? contrast?.contrastColor
                    : "#101e8e",
                  position: "absolute",
                  marginTop: "26px",
                  marginLeft:
                    General?.codeLabels["cm_pdc_paymentaccounts"]
                      ?.languageCode != "ARA"
                      ? "300px"
                      : "",
                  left:
                    General?.codeLabels["cm_pdc_paymentaccounts"]
                      ?.languageCode == "ARA"
                      ? "6rem"
                      : "",
                  opacity: !showContent ? 0.5 : 1,
                  cursor: !showContent ? "not-allowed" : "pointer",
                }}
                onClick={() => {
                  setValue(5);
                }}
                //className={General?.colorClass}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="30"
                  height="36"
                  viewBox="0 0 30 36"
                  fill="none"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M12.1429 2.88C12.1429 1.29656 13.4291 0 15 0C16.5709 0 17.8571 1.29656 17.8571 2.88C17.8571 3.25125 17.7846 3.61125 17.6562 3.9375C21.6685 4.995 24.2857 8.51063 24.2857 12.96C24.2857 18.5991 25.6585 21.1669 26.9643 22.6125C27.5344 23.2437 28.0982 23.6583 28.6017 24.0285L28.6018 24.0286C28.6748 24.0823 28.7466 24.1351 28.817 24.1875C29.096 24.3928 29.3499 24.5981 29.5759 24.8625C29.8019 25.1269 30 25.5037 30 25.92C30 26.91 29.3973 27.7509 28.5491 28.305C27.7009 28.8591 26.5876 29.2162 25.2455 29.4975C23.5045 29.8603 21.356 30.0516 18.9955 30.15C19.1769 30.6253 19.2857 31.14 19.2857 31.68C19.2857 34.0566 17.3577 36 15 36C12.6423 36 10.7143 34.0566 10.7143 31.68C10.7143 31.1428 10.8259 30.6281 11.0045 30.15C8.64397 30.0516 6.49554 29.8603 4.75446 29.4975C3.41239 29.2162 2.29911 28.8591 1.45089 28.305C0.602679 27.7509 0 26.91 0 25.92C0 25.5037 0.198103 25.1269 0.424107 24.8625C0.650111 24.5981 0.904018 24.3928 1.18304 24.1875C1.25343 24.1351 1.32525 24.0823 1.39834 24.0285C1.90183 23.6583 2.46558 23.2437 3.03571 22.6125C4.34152 21.1669 5.71429 18.5991 5.71429 12.96C5.71429 8.50781 8.32589 4.98938 12.3438 3.9375C12.2154 3.61125 12.1429 3.25125 12.1429 2.88ZM16.4286 2.88C16.4286 2.07563 15.798 1.44 15 1.44C14.202 1.44 13.5714 2.07563 13.5714 2.88C13.5714 3.68438 14.202 4.32 15 4.32C15.798 4.32 16.4286 3.68438 16.4286 2.88ZM16.6741 5.175C20.4827 5.85844 22.8571 8.82563 22.8571 12.96C22.8571 18.8409 24.3415 21.8616 25.8929 23.58C26.5813 24.3414 27.2764 24.8502 27.7849 25.2224L27.7849 25.2224L27.7852 25.2226C27.8495 25.2697 27.9108 25.3146 27.9688 25.3575C28.2254 25.5488 28.418 25.7091 28.5045 25.8075C28.5765 25.8895 28.575 25.8973 28.5725 25.9107C28.572 25.9133 28.5714 25.9162 28.5714 25.92C28.5714 26.37 28.365 26.6991 27.7679 27.09C27.1708 27.4809 26.1998 27.8438 24.9554 28.1025C22.4665 28.6228 18.923 28.8 15 28.8C11.077 28.8 7.53348 28.6228 5.04464 28.1025C3.80022 27.8438 2.82924 27.4809 2.23214 27.09C1.63504 26.6991 1.42857 26.37 1.42857 25.92C1.42857 25.9162 1.42802 25.9133 1.42752 25.9107C1.425 25.8973 1.42352 25.8895 1.49554 25.8075C1.58203 25.7091 1.77455 25.5488 2.03125 25.3575C2.08928 25.3145 2.1507 25.2695 2.21511 25.2224L2.21512 25.2224C2.72363 24.8502 3.41868 24.3414 4.10714 23.58C5.65848 21.8616 7.14286 18.8409 7.14286 12.96C7.14286 8.82844 9.52009 5.88375 13.3259 5.1975C13.8002 5.54906 14.3722 5.76 15 5.76C15.6334 5.76 16.1998 5.53219 16.6741 5.175ZM13.2086 30.2107C12.986 30.2051 12.7648 30.1996 12.5446 30.195C12.2852 30.6281 12.1429 31.1344 12.1429 31.68C12.1429 33.2803 13.4124 34.56 15 34.56C16.5876 34.56 17.8571 33.2803 17.8571 31.68C17.8571 31.14 17.7093 30.6281 17.4554 30.195C17.2352 30.1996 17.0139 30.2051 16.7914 30.2107C16.2047 30.2252 15.6089 30.24 15 30.24C14.3911 30.24 13.7953 30.2252 13.2086 30.2107Z"
                    fill={
                      General?.contrast?.contrastBackground
                        ? General.contrast.contrastBackground
                        : "white"
                    }
                  />
                </svg>
                <div
                  style={{
                    backgroundColor: General.contrast.contrastBackground
                      ? General.contrast.contrastBackground
                      : ColorAss === "#101e8e"
                      ? ColorAss
                      : "#62AA51",
                    color: General.contrast.contrastColor
                      ? General.contrast.contrastColor
                      : "",
                  }}
                >
                  {notificationCount}
                </div>
              </NotificationButton>
            </Box>
          ) : (
            ""
          )}
        </Box>
        <TabPanel value={value} index={0} width="100%" padding={0}>
          <DashboardCards
            setValue={setValue}
            setInnerValue={setInnerValue}
            viewAll={viewAll}
          />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <Div
            style={{
              backgroundColor: contrast?.contrastBackground
                ? contrast?.contrastBackground
                : "",
              color: contrast?.contrastColor
                ? contrast?.contrastColor
                : General?.ColorAss,
            }}
            className="text-container"
          >
            <div
              className=" px-3 d-flex justify-content-between align-items-center"
              style={{
                minHeight: "154px",
                width: isLargeScreen ? "94vw" : "100%",
              }}
            >
              <div
                className="pr-3"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: isLargeScreen ? "70vw" : "60vw",
                  justifyContent: "center",
                  height: "125px",
                  paddingTop: "30px",
                  marginLeft: isLargeScreen ? "80px" : "0px",
                  gap: "10px",
                }}
              >
                <h2
                  className="py-lg-0 py-2"
                  style={{
                    color: General.contrast.contrastColor
                      ? General.contrast.contrastColor
                      : General?.ColorAss,
                    fontFamily: "Segoe UI",
                    fontStyle: "normal",
                    fontWeight: isLargeScreen ? "400" : "600",
                    fontSize: isLargeScreen
                      ? `${2.75 * General.accessibility.fontSize}rem`
                      : `${1.5 * General.accessibility.fontSize}rem`,
                    lineHeight: isLargeScreen ? "48px" : "",
                    margin: 0,
                    paddingRight:
                      General?.codeLabels["cm_pdc_paymentaccounts"]
                        ?.languageCode == "ARA"
                        ? General?.isLargeScreen
                          ? "80px"
                          : ""
                        : "",
                  }}
                >
                  {General?.codeLabels["cm_payment_and_receipt"]?.label
                    ? General?.codeLabels["cm_payment_and_receipt"]?.label
                    : "Payments & Receipts"}
                </h2>
                <p
                  style={{
                    color: General.contrast.contrastColor
                      ? General.contrast.contrastColor
                      : General?.ColorAss,
                    fontSize: isLargeScreen
                      ? `${0.875 * General.accessibility.fontSize}rem`
                      : `${0.625 * General.accessibility.fontSize}rem`,
                    fontFamily: "Segoe UI",
                    fontStyle: "normal",
                    fontWeight: "400",
                    paddingRight:
                      General?.codeLabels["cm_pdc_paymentaccounts"]
                        ?.languageCode == "ARA"
                        ? General?.isLargeScreen
                          ? "80px"
                          : ""
                        : "",
                    width: isLargeScreen ? "" : "300px",
                  }}
                  // className="DynamicTextColor"
                >
                  {General?.codeLabels["cm_payment_receipt_info"]?.label
                    ? General?.codeLabels["cm_payment_receipt_info"]?.label
                    : "View all pending payments, view past bills, receipts and payment history for all accounts. View all post dated cheques submitted."}
                </p>
              </div>
              <div>
                <Button
                  onClick={handleAutoPay}
                  style={{
                    width: isLargeScreen ? "150px" : "",
                    minHeight: "35px",
                    paddingLeft: "5px",
                    paddingRight: "5px",
                    fontFamily: "Segoe UI",
                    fontStyle: "normal",
                    fontWeight: "700",
                    fontSize: isLargeScreen
                      ? `${0.875 * General.accessibility.fontSize}rem`
                      : `${0.625 * General.accessibility.fontSize}rem`,
                    textTransform: "uppercase",
                    marginTop: "10%",
                    color: General.contrast.contrastColor
                      ? General.contrast.contrastBackground
                      : "#fff",
                    background: General.contrast.contrastBackground
                      ? General.contrast.contrastColor
                      : General?.ColorAss,
                    border: "none",
                  }}
                  //className="DynamicButtonColor"
                >
                  {General?.codeLabels["cm_en_auto"]?.label
                    ? General?.codeLabels["cm_en_auto"]?.label
                    : "ENABLE AUTO-PAY"}
                </Button>
              </div>
            </div>
          </Div>
          <PaymentTabs value={innerValue} setValue={setInnerValue} />
        </TabPanel>
        <TabPanel value={value} index={2}>
          <Div
            style={{
              backgroundColor: contrast?.contrastBackground
                ? contrast?.contrastBackground
                : "#E7E9F8",
              color: contrast?.contrastColor ? contrast?.contrastColor : "",
            }}
          >
            <Box
              style={{
                backgroundColor: contrast?.contrastBackground
                  ? contrast?.contrastBackground
                  : "",
                color: contrast?.contrastColor
                  ? contrast?.contrastColor
                  : ColorAss,
                width: "100vw",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "start",
                height: "150px",
                paddingTop: "30px",
              }}
            >
              <div
                className="px-lg-0 px-3"
                style={{
                  marginLeft: isLargeScreen ? "80px" : "",
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                }}
              >
                <h2
                  style={{
                    color: General.contrast.contrastColor
                      ? General.contrast.contrastColor
                      : General?.ColorAss,
                    fontFamily: "Segoe UI",
                    fontStyle: "normal",
                    fontWeight: isLargeScreen ? "400" : "600",
                    fontSize: isLargeScreen
                      ? `${2.75 * General.accessibility.fontSize}rem`
                      : `${1.5 * General.accessibility.fontSize}rem`,
                    lineHeight: "48px",
                    margin: 0,
                    paddingRight:
                      General?.codeLabels["cm_pdc_paymentaccounts"]
                        ?.languageCode == "ARA"
                        ? General?.isLargeScreen
                          ? "80px"
                          : ""
                        : "",
                  }}
                  //className="DynamicTextColor"
                >
                  {General?.codeLabels["cm_noc_request"]?.label
                    ? General?.codeLabels["cm_noc_request"]?.label
                    : "NOCs & Requests"}
                </h2>
                <p
                  style={{
                    color: General.contrast.contrastColor
                      ? General.contrast.contrastColor
                      : ColorAss,
                    fontSize: isLargeScreen
                      ? `${0.875 * General.accessibility.fontSize}rem`
                      : `${0.625 * General.accessibility.fontSize}rem`,
                    fontFamily: "Segoe UI",
                    fontStyle: "normal",
                    fontWeight: "400",
                    paddingRight:
                      General?.codeLabels["cm_pdc_paymentaccounts"]
                        ?.languageCode == "ARA"
                        ? General?.isLargeScreen
                          ? "80px"
                          : ""
                        : "",
                  }}
                  //className="DynamicTextColor"
                >
                  {General?.codeLabels["cm_noc_request_info"]?.label
                    ? General?.codeLabels["cm_noc_request_info"]?.label
                    : " You can view all valid NOCs and all past requests with their status"}
                </p>
              </div>
            </Box>
          </Div>
          <NocTabs tabIndex={nocTab} />
        </TabPanel>
        <TabPanel value={value} index={3}>
          <Div>
            <section
              style={{
                backgroundColor: contrast?.contrastBackground
                  ? contrast?.contrastBackground
                  : "#E7E9F8",
                width: "100vw",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "start",
                height: "150px",
                paddingTop: "30px",
              }}
            >
              <div
                className="px-3"
                style={{
                  marginLeft: isLargeScreen ? "80px" : "",
                  display: "flex",
                  gap: "10px",
                  flexDirection: "column",
                }}
              >
                <h2
                  style={{
                    color: General.contrast.contrastColor
                      ? General.contrast.contrastColor
                      : ColorAss,
                    fontFamily: "Segoe UI",
                    fontStyle: "normal",

                    fontWeight: isLargeScreen ? "400" : "600",
                    fontSize: isLargeScreen
                      ? `${2.75 * General.accessibility.fontSize}rem`
                      : `${1.5 * General.accessibility.fontSize}rem`,
                    lineHeight: "48px",
                    margin: 0,
                    paddingRight:
                      General?.codeLabels["cm_pdc_paymentaccounts"]
                        ?.languageCode == "ARA"
                        ? "80px"
                        : "",
                  }}
                >
                  {General?.codeLabels["cm_my_acc"]?.label
                    ? General?.codeLabels["cm_my_acc"]?.label
                    : "My Accounts"}
                </h2>
                <p
                  style={{
                    color: General.contrast.contrastColor
                      ? General.contrast.contrastColor
                      : ColorAss,
                    fontSize: isLargeScreen
                      ? `${0.875 * General.accessibility.fontSize}rem`
                      : `${0.625 * General.accessibility.fontSize}rem`,
                    fontFamily: "Segoe UI",
                    fontStyle: "normal",
                    paddingRight:
                      General?.codeLabels["cm_pdc_paymentaccounts"]
                        ?.languageCode == "ARA"
                        ? "80px"
                        : "",
                  }}
                >
                  {General?.codeLabels["cm_my_acc_info"]?.label
                    ? General?.codeLabels["cm_my_acc_info"]?.label
                    : "All your accounts and details"}
                </p>
              </div>
            </section>
          </Div>
          <AccountGrid MyAccountsWidth="93%" MyAccountsOutline="none" />
        </TabPanel>
        <TabPanel value={value} index={4}>
          <ServicesTab setValue={setValue} setInnerValue={setInnerValue} />
        </TabPanel>
        <TabPanel value={value} index={5}>
          <Notifications getNotificationCount={getNotificationCount} />
        </TabPanel>

        <TabPanel value={value} index={6}>
          <section
            style={{
              backgroundColor: contrast?.contrastBackground
                ? contrast?.contrastBackground
                : "#E7E9F8",
              width: "98.7vw",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "start",
              height: "150px",
              paddingTop: "30px",
            }}
          >
            <div
              style={{
                marginLeft: General?.isLargeScreen ? "80px" : "1.2rem",
                display: "flex",
                flexDirection: "column",
                gap: "10px",
              }}
            >
              <h2
                style={{
                  color: contrast?.contrastColor
                    ? contrast?.contrastColor
                    : ColorAss,
                  fontFamily: "Segoe UI",
                  fontStyle: "normal",
                  fontWeight: "400",
                  fontSize: `${2.75 * General.accessibility.fontSize}rem`,
                  lineHeight: "48px",
                  margin: 0,
                  paddingRight:
                    General?.codeLabels["cm_pdc_paymentaccounts"]
                      ?.languageCode == "ARA"
                      ? "80px"
                      : "",
                }}
              >
                {General?.codeLabels["cm_accsummary"]?.label !== undefined
                  ? General?.codeLabels["cm_accsummary"]?.label
                  : "Profile"}
              </h2>
              <p
                style={{
                  color: contrast?.contrastColor
                    ? contrast?.contrastColor
                    : ColorAss,
                  fontSize: `${0.875 * General.accessibility.fontSize}rem`,
                  fontFamily: "Segoe UI",
                  fontStyle: "normal",
                  fontWeight: "500",
                  paddingRight:
                    General?.codeLabels["cm_pdc_paymentaccounts"]
                      ?.languageCode == "ARA"
                      ? "80px"
                      : "",
                }}
              >
                {General?.codeLabels["cm_my_acc_profile"]?.label
                  ? General?.codeLabels["cm_my_acc_profile"]?.label
                  : "View all details related to your profile, documents and bank details"}
              </p>
            </div>
          </section>
          <ProfileTabs />
        </TabPanel>

        <TabPanel value={value} index={7}>
          <section
            style={{
              backgroundColor: General.contrast.contrastBackground
                ? General.contrast.contrastBackground
                : "#E7E9F8",
              width: "98.7vw",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "start",
              height: "150px",
              paddingTop: "30px",
            }}
          >
            <div style={{ marginLeft: "80px" }}>
              <h2
                style={{
                  color: contrast?.contrastColor
                    ? contrast?.contrastColor
                    : ColorAss,
                  fontFamily: "Segoe UI",
                  fontStyle: "normal",
                  fontWeight: "400",
                  fontSize: `${2.75 * General.accessibility.fontSize}rem`,
                  lineHeight: "48px",
                  margin: 0,
                  paddingRight:
                    General?.codeLabels["cm_pdc_paymentaccounts"]
                      ?.languageCode == "ARA"
                      ? "80px"
                      : "",
                }}
              >
                {General?.codeLabels["cm_ds_auto"]?.label
                  ? General?.codeLabels["cm_ds_auto"]?.label
                  : "Auto Payment"}
              </h2>
              <p
                style={{
                  color: contrast?.contrastColor
                    ? contrast?.contrastColor
                    : ColorAss,
                  fontSize: `${0.875 * General.accessibility.fontSize}rem`,
                  fontFamily: "Segoe UI",
                  fontStyle: "normal",
                  fontWeight: "500",
                  paddingRight:
                    General?.codeLabels["cm_pdc_paymentaccounts"]
                      ?.languageCode == "ARA"
                      ? "80px"
                      : "",
                }}
              >
                {General?.codeLabels["cm_ser_manage"]?.label
                  ? General?.codeLabels["cm_ser_manage"]?.label
                  : "Manage your Cards & Accounts"}
              </p>
            </div>
          </section>
          <AutoPay />
        </TabPanel>
        <Modal
          open={informationModal}
          onClose={() => {}}
          // onClick={handleClose}
        >
          <InformationModal
            onCross={() => setInformationModal(false)}
            status={"Pending"}
            details={{}}
          />
        </Modal>
      </Box>
    </>
  );
});
